module.exports = __webpack_public_path__ + "img/FilterOptionsDatePicker.76ebd608.jpg";